export default {
  props: {
    maxWidth: {
      type: String,
      default: '185px'
    }
  }
}
